/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../../api/index';
import * as core from '../../../../../core';
import * as serializers from '../../../../index';

export const DidcommMessageUpdateAnnotationsRequest: core.serialization.Schema<
    serializers.DidcommMessageUpdateAnnotationsRequest.Raw,
    Omit<Truvity.DidcommMessageUpdateAnnotationsRequest, 'idempotencyKey' | 'ifMatch'>
> = core.serialization.object({
    annotations: core.serialization.record(core.serialization.string(), core.serialization.string()),
});

export declare namespace DidcommMessageUpdateAnnotationsRequest {
    export interface Raw {
        annotations: Record<string, string>;
    }
}
